import { forwardRef, type Ref, type SVGProps } from "react";
const IconHouseClockFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27.29 11.4 17.2 1.9a2 2 0 0 0-2.4 0L4.71 11.4A2 2 0 0 0 4 12.93V28a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V12.93a2 2 0 0 0-.71-1.53M16 24a5 5 0 1 1 0-10 5 5 0 0 1 0 10m2.89-3.55A1 1 0 0 1 18 21a.93.93 0 0 1-.45-.11L15 19.62V17a1 1 0 1 1 2 0v1.38l1.45.73a1 1 0 0 1 .44 1.34"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHouseClockFilledSVG);
ForwardRef.displayName = "IconHouseClockFilled";
export { ForwardRef as IconHouseClockFilled };
